/* eslint-disable */
import { Button } from '@mui/material';
/* eslint-disable object-curly-newline */
import { useCallback, useEffect, useMemo, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Ticks } from 'chart.js';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './BOMAnalysisGraph.module.scss';
import TimeFilter from '../../../TimeFilter/TimeFilter';
import {
	classes,
	convertTo24HourFormatTo12Hour,
	getDayName,
	groupTypeFilterList,
	inputHelper,
	useTimeFilter,
} from '../../../../Helpers';
import { BarChart } from '../../Charts';
import { COGS_CHART_COLORS } from '../../../../Styles/colors';
import { urls } from '../../../../Constants';
import { timeFilterMap } from '../../../../Constants/analytics.constansts';
import analyticsAction from '../../../../Actions/analytics.actions';
import analyticsTypeConstant from '../../../../Constants/analyticsType.contants';
import FilterModal from '../../../Filter Modal/FilterModal';
import { useAuth } from '../../../Auth/Login/auth';
import { Tabs, TabsList, TabsTrigger } from '@/Components/ui/tabs';
import { UYDateRange } from '@/Components/Forms/Payment Settlements/Calender/UYDateRange';
import moment from 'moment';
import { DatePicker } from 'rsuite';
import { modalActions } from '@/Actions';
import alert from '@/Images/alertImages.png';

/**
 * ! don't forget to change the index in handleBarChartClick, when changing this array
 */

const DISCRETE_TIME_FILTERS = [
	{
		text: 'YTD',
		type: 'year',
		active: true,
	},
	{
		text: 'MTD',
		type: 'month',
		active: false,
	},
	{
		text: 'DTD',
		type: 'day',
		active: false,
	},
];

const FILTERS = [
	'GEO_FILTER',
	'DATE_FILTER',
	// 'BRAND_FILTER',
	// 'FAILURE_ANALYSIS_FILTER',
	// 'STATISTICAL_FILTER',
	'STORE_FILTER',
];

const BOMAnalysisGraph = (props) => {
	const {
		timeFilter,
		qualityData,
		listURL,
		setAnalyticsType,
		applyFilters,
		isClear,
		GROUP_TYPE_FILTER,
		setTypeFilter,
		brandsList,
		dateRangeFilter,
		setDateRangeFilter,
	} = props;
	const { appConfig = {}, userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const { measurement } = appConfig?.configs ?? {};
	const isA2bCustomer = appConfig?.customerId === 68 || appConfig?.customerId === 5 || appConfig?.customerId === 52;
	const [pageLimit, setPageLimit] = useState({
		number: 1,
		limit: 31,
	});
	const [graphYear, setGraphYear] = useState(new Date().getFullYear());
	const viewTabValue = useSelector((state) => state.analytics.BOM_CHART_VIEW);
	const isProductSelect = useSelector((state) => state.analytics.VARIANT_FILTER);
	const selectedShift = useSelector((state) => state.analytics.SHIFT_FILTER);
	const dispatch = useDispatch();
	const history = useHistory();
	const [clickedMonth, setClickedMonth] = useState(0);
	const analyticsType = useSelector((state) => state.analytics.analyticsType);

	useEffect(() => {
		setAnalyticsType(
			analyticsTypeConstant.BOM_ANALYTICS_CHART_DATA,
			{},
			false
		);
		setDateRangeFilter({
			...dateRangeFilter,
			from: new Date(moment().startOf('month').format('YYYY-MM-DD')),
			to: new Date(moment().format('YYYY-MM-DD')),
			active: false,
		});
	}, []);

	useEffect(() => {
		const brand = {
			brand: {
				value: brandsList?.[0]?.id,
				label: brandsList?.[0]?.name,
			},
		};
		applyFilters(
			{
				GROUP_TYPE_FILTER: {
					...GROUP_TYPE_FILTER,
					active: true,
					type: 'periodWise',
					selection: {
						...brand,
					},
				},
			},
			false
		);
	}, [brandsList]);


	const { setTimeFilter, timeFilters } = useTimeFilter({
		DISCRETE_TIME_FILTERS,
		applyFilters,
	});

	const isYearActive = useMemo(() => {
		return GROUP_TYPE_FILTER?.type === 'periodWise' && timeFilters.find((ele) => ele.type === 'year')?.active && isA2bCustomer;
	}, [timeFilters, GROUP_TYPE_FILTER?.type, isA2bCustomer]);

	const barChartData = useMemo(() => {
		const {
			labels = [],
			dataset = [],
			labelIds = [],
		} = qualityData?.chartData ?? {
			labels: [],
			dataset: [],
			labelIds: [],
		};

		// Calculate the start and end indices for the current page
		const startIdx = pageLimit?.limit * (pageLimit?.number - 1);
		const endIdx = pageLimit?.limit * pageLimit?.number;

		// Filter labels and labelIds based on the calculated indices
		const filteredLabels = labels.slice(startIdx, endIdx);
		const filteredLabelIds = labelIds.slice(startIdx, endIdx);

		// Filter and map the dataset
		const filteredDatasets = dataset.map((ds, idx) => {
			const dsData = ds?.data?.slice?.(startIdx, endIdx) ?? [];
			return {
				...COGS_CHART_COLORS[idx % COGS_CHART_COLORS.length],
				...ds,
				yAxisID: ds?.yAxisID ?? 'y',
				data: dsData,
			};
		});

		return {
			labels: filteredLabels,
			labelIds: filteredLabelIds,
			datasets: filteredDatasets,
		};
	}, [qualityData?.chartData, GROUP_TYPE_FILTER, pageLimit]);

	const resetPageNumber = () => {
		setPageLimit((prev) => {
			return {
				...prev,
				number: 1,
			};
		});
	};

	const handleBarChartClick = useCallback(
		(elem) => {
			if (elem.length > 0) {
				const datasetIndex = elem[0].index;
				const selection = barChartData.labelIds?.[datasetIndex];
				const selectionText = barChartData.labels?.[datasetIndex];
				if (GROUP_TYPE_FILTER?.type === 'periodWise') {
					switch (timeFilter.type) {
						case 'year':
							setTimeFilter('month', {
								year: timeFilter.selection.year,
								month: timeFilterMap.month[selection - 1],
								day: null,
								hour: null,
								week: null,
							});
							break;
						case 'month':
							setTimeFilter('day', {
								year: timeFilter.selection.year,
								month: timeFilter.selection.month,
								day: selection,
								hour: null,
								week: null,
							});
							break;
						case 'hour':
							setTimeFilter('hour', {
								year: timeFilter.selection.year,
								month: timeFilter.selection.month,
								day: timeFilter.selection.day,
								hour: selection,
								week: timeFilter.selection.week,
							});
							history.push(
								listURL ??
								`${urls.EXTENSION}${urls.BOM_ANALYSIS_LIST}`
							);
							break;
						case 'week':
						case 'day':
							setTimeFilter('hour', {
								year: timeFilter.selection.year,
								month: timeFilter.selection.month,
								week: null,
								day: timeFilter.selection.day,
								hour: selection,
							});
							history.push(
								listURL ??
								`${urls.EXTENSION}${urls.BOM_ANALYSIS_LIST}`
							);
							break;
						default:
							break;
					}
				}
				if (GROUP_TYPE_FILTER?.type === 'productGroupWise') {
					switch (GROUP_TYPE_FILTER?.currentSelection) {
						case 'brand':
							applyFilters({
								GROUP_TYPE_FILTER: {
									...GROUP_TYPE_FILTER,
									active: true,
									type: GROUP_TYPE_FILTER?.type,
									currentSelection: 'category',
									selection: {
										...GROUP_TYPE_FILTER?.selection,
										category: {
											value: barChartData.labelIds?.[
												datasetIndex
											],
											label: selectionText,
										},
									},
								},
							});
							resetPageNumber();
							break;
						case 'category':
							applyFilters({
								GROUP_TYPE_FILTER: {
									...GROUP_TYPE_FILTER,
									active: true,
									type: GROUP_TYPE_FILTER?.type,
									currentSelection: 'subCategory',
									selection: {
										...GROUP_TYPE_FILTER?.selection,
										subCategory: {
											value: barChartData.labelIds?.[
												datasetIndex
											],
											label: selectionText,
										},
									},
								},
							});
							resetPageNumber();
							break;

						case 'subCategory':
							history.push(
								listURL ??
								`${urls.EXTENSION}${urls.BOM_ANALYSIS_LIST}`
							);
							resetPageNumber();
							break;
						default:
							break;
					}
				}
				if (GROUP_TYPE_FILTER?.type === 'geographyWise') {
					switch (GROUP_TYPE_FILTER?.currentSelection) {
						case 'brand':
							applyFilters({
								GROUP_TYPE_FILTER: {
									...GROUP_TYPE_FILTER,
									active: true,
									type: GROUP_TYPE_FILTER?.type,
									currentSelection: 'region',
									selection: {
										...GROUP_TYPE_FILTER?.selection,
										region: {
											value: barChartData.labelIds?.[
												datasetIndex
											],
											label: selectionText,
										},
									},
								},
							});
							resetPageNumber();

							break;
						case 'region':
							applyFilters({
								GROUP_TYPE_FILTER: {
									...GROUP_TYPE_FILTER,
									active: true,
									type: GROUP_TYPE_FILTER?.type,
									currentSelection: 'city',
									selection: {
										...GROUP_TYPE_FILTER?.selection,
										city: {
											value: barChartData.labelIds?.[
												datasetIndex
											],
											label: selectionText,
										},
									},
								},
							});
							resetPageNumber();

							break;

						case 'city':
							history.push(
								listURL ??
								`${urls.EXTENSION}${urls.BOM_ANALYSIS_LIST}`
							);
							resetPageNumber();

							break;
						default:
							break;
					}
				}
			}
		},
		[timeFilter, setTimeFilter, GROUP_TYPE_FILTER, setTypeFilter]
	);

	const formatTicks = (chartThis, value, index, ticks) => {
		const newValue = chartThis.getLabelForValue(value);
		if (GROUP_TYPE_FILTER?.type === 'periodWise') {
			if (timeFilters[0].active) {
				return timeFilterMap.month[value];
			}
			if (timeFilters[1].active) {
				const date = [
					timeFilters[0].text,
					timeFilterMap.monthNumber[timeFilters[1].text],
					newValue,
				];
				return `${newValue}-${getDayName(
					new Date(...date).getDay()
				)?.substring(0, 3)}`;
			}
			if (timeFilters[2].active) {
				return convertTo24HourFormatTo12Hour(value);
			}
		}
		return Ticks.formatters.values.apply(chartThis, [
			newValue,
			index,
			ticks,
		]);
	};

	const handlePastYearSelection = (e) => {
		const { fieldValue } = inputHelper(e);

		setTimeFilter('year', {
			year: fieldValue,
			month: timeFilterMap.month[new Date().getUTCMonth()],
			day: null,
			hour: null,
			week: null,
		});
		setGraphYear(fieldValue);
	};

	const handleFilterType = (value) => {
		const typeFilterData = groupTypeFilterList?.find((ele) => {
			return ele?.value === value;
		});
		const brand = {
			brand: {
				value: brandsList?.[0]?.id,
				label: brandsList?.[0]?.name,
			},
		};
		if (typeFilterData?.value === 'periodWise') {
			setDateRangeFilter({
				...dateRangeFilter,
				active: false,
			});
		} else {
			setDateRangeFilter({
				...dateRangeFilter,
				active: true,
			});
		}
		applyFilters({
			GROUP_TYPE_FILTER: {
				...GROUP_TYPE_FILTER,
				active: true,
				type: typeFilterData?.value,
				currentSelection: typeFilterData?.currentSelection,
				selection: {
					...brand,
					...typeFilterData?.selection,
				},
			},
		});
		resetPageNumber();
	};

	const handleTypeFilter = (type) => {
		// setTypeFilter({
		// ...GROUP_TYPE_FILTER,
		// currentSelection: type,
		// });
		applyFilters({
			GROUP_TYPE_FILTER: {
				...GROUP_TYPE_FILTER,
				currentSelection: type,
			},
		});
		resetPageNumber();
	};

	const dateRangeFilterArray = useMemo(() => {
		return [
			{
				startDate: dateRangeFilter.from,
				endDate: dateRangeFilter.to,
				key: 'selection',
			},
		];
	}, [dateRangeFilter]);

	const setDate = (newDate) => {
		const { startDate: from, endDate: to } = newDate?.selection ?? {};

		setDateRangeFilter({
			active: true,
			from,
			to,
		});
		applyFilters({});
	};

	const handleBomChartView = (value) => {
		dispatch(analyticsAction.applyBomChartView(value, true));
	}
	const buildDateRangeFromTimeFilter = () => {
		const { selection } = timeFilter;
		const { year, month, day, hour } = selection;

		// Convert month name to month number (0-indexed)
		const monthNumber = timeFilterMap.monthNumber[month];

		let fromDate, toDate;

		const today = moment().startOf('day');
		if (hour !== null) {
			// Hour level - same day, specific hour
			fromDate = moment(`${year}-${monthNumber + 1}-${day}`, 'YYYY-MM-DD').startOf('day');
			toDate = moment(`${year}-${monthNumber + 1}-${day}`, 'YYYY-MM-DD').endOf('day');
		} else if (day !== null) {
			// Day level - specific day
			fromDate = moment(`${year}-${monthNumber + 1}-${day}`, 'YYYY-MM-DD').startOf('day');
			toDate = moment(`${year}-${monthNumber + 1}-${day}`, 'YYYY-MM-DD').endOf('day');
		} else if (month !== null) {
			// Month level - entire month
			fromDate = moment(`${year}-${monthNumber + 1}`, 'YYYY-MM').startOf('month');
			toDate = moment(`${year}-${monthNumber + 1}`, 'YYYY-MM').endOf('month');
		} else {
			// Year level - entire year
			fromDate = moment(`${year}`, 'YYYY').startOf('year');
			toDate = moment(`${year}`, 'YYYY').endOf('year');
		}
		// Ensure toDate is always less than today
		if (toDate.isSameOrAfter(today, 'day')) {
			toDate = today.clone().subtract(1, 'day').endOf('day');
			// If fromDate is after toDate, set fromDate = toDate.startOf('day')
			if (fromDate.isAfter(toDate, 'day')) {
				fromDate = toDate.clone().startOf('day');
			}
		}

		return {
			from: fromDate.toDate(),
			active: true,
			to: toDate.toDate(),
		};
	}

	const showDateRangeFilter = () => {
		return (
			<div className='w-full flex justify-center'>
				<div className='w-[300px]'>
					<DatePicker
						className='w-[300px]'
						placeholder='Select Date Range'
						format='MMM yyyy'
						oneTap
						placement='topStart'
						appearance='default'
						type='month'
						style={{
							width: '100%',
						}}
						defaultOpen
						cleanable={false}
						onChange={(value) => {
							const newTimeFilter = {
								active: true,
								selection: {
									year: value.getFullYear(),
									month: timeFilterMap.month[value.getMonth()],
									day: null,
									hour: null,
									week: 1,
								},
								text: timeFilterMap.month[value.getMonth()],
								type: 'month',
							};
							applyFilters({
								DATE_FILTER: newTimeFilter,
							}, true);
						}}
					/>
				</div>
			</div>
		);
	};
	useEffect(() => {
		if (timeFilter.active && timeFilter.type === 'month' && isA2bCustomer) {
			setClickedMonth((prev) => prev + 1);
		}
	}, []);

	const handleRedirection = () => {
		if (appConfig?.customerId === 68 || appConfig?.customerId === 5) {
			let dateRangeFilterObj = null;

			if (dateRangeFilter.active) {
				// Use the active dateRangeFilter
				dateRangeFilterObj = {
					from: dateRangeFilter.from,
					active: true,
					to: dateRangeFilter.to,
				};
			} else {
				// Convert timeFilter to dateRange format
				dateRangeFilterObj = buildDateRangeFromTimeFilter();
			}
			const url = `${urls.EXTENSION}${urls.AI_FMS_PAGE}?parentValue=PRODUCED&dateRange=${JSON.stringify(dateRangeFilterObj)}&mealTypeId=${selectedShift?.value ?? ''}`;
			window.open(url, '_blank');
		} else {
			const url = listURL ?? `${urls.EXTENSION}${urls.BOM_ANALYSIS_LIST}`;
			history.push(`${url}`);
		}
	}

	const renderOnClick = (type, filter) => {
		if (
			analyticsType === analyticsTypeConstant.BOM_ANALYTICS_CHART_DATA &&
			type === 'month' && isA2bCustomer
		) {
			return setTimeFilter(type, filter, clickedMonth);
		}
		return setTimeFilter(type);
	};

	const iconData = useMemo(() => {
		if (!barChartData?.labels?.length || GROUP_TYPE_FILTER?.type !== 'periodWise') {
			return null;
		}
		const iconMonths = qualityData?.chartData?.priceValidated?.notValidatedMonth ?? [];
		const result = barChartData.labels.map((label) => iconMonths?.includes(label));
		return result;
	}, [barChartData?.labels, GROUP_TYPE_FILTER?.type, qualityData?.chartData?.priceValidated]);

	const handleIconClick = () => {
		if (level > 1 && isA2bCustomer) {
			dispatch(modalActions.toggleRmPriceModal(true));
		}
	}

	const iconTooltipFormatter = (data, index) => {
		return 'RM Price Not Validated for this month';
	};

	return (
		<div className={classes(styles.root)}>
			<FilterModal type='bom' filters={FILTERS} clear={isClear} />
			<div className='flex items-baseline gap-3'>
				<div className='flex flex-col gap-2 '>
					<Tabs
						value={GROUP_TYPE_FILTER?.type}
						onValueChange={handleFilterType}
						defaultValue={GROUP_TYPE_FILTER?.type}
					>
						<TabsList className=''>
							{groupTypeFilterList?.map((ele) => {
								return (
									<TabsTrigger
										className='data-[state=active]:bg-uy-color'
										value={ele?.value}
									>
										{ele?.label}
									</TabsTrigger>
								);
							})}
						</TabsList>
					</Tabs>
					{GROUP_TYPE_FILTER?.type !== 'periodWise' && (
						<UYDateRange
							disabled={!dateRangeFilter.active}
							dateRanges={dateRangeFilterArray}
							onDateRangeChange={setDate}
							enableOnlyBackwardSelection={false}
							menuStyles={{
								zIndex: 999,
							}}
							placement='bottomStart'
						/>
					)}
				</div>
				{isA2bCustomer && (
					<Tabs
						value={viewTabValue}
						onValueChange={handleBomChartView}
						defaultValue={viewTabValue}
					>
						<TabsList className=''>
							{['TotalWeight', 'TotalCost', 'PerUnit']?.map((ele) => {
								return (
									<TabsTrigger
										className='data-[state=active]:bg-uy-color'
										value={ele}
									>
										{ele}
									</TabsTrigger>
								);
							})}
						</TabsList>
					</Tabs>
				)}
				<Button
					className={classes(styles['list-button'])}
					variant='contained'
					color='primary'
					style={{
						color: 'black',
					}}
					onClick={handleRedirection}
				>
					View  {isA2bCustomer ? 'Summary' : 'List'}
				</Button>
			</div>
			<div className='relative w-full'>
				{qualityData?.chartData?.labels?.length > pageLimit?.limit && (
					<div className='absolute flex items-center gap-4 -top-8 left-[50%] translate-x-[-50%]'>
						<Button
							onClick={() => {
								if (pageLimit?.number > 1) {
									setPageLimit((prev) => {
										return {
											...prev,
											number: prev?.number - 1,
										};
									});
								}
							}}
							variant='outline'
							size='icon'
							disabled={pageLimit?.number === 1}
						>
							<ChevronLeft className='h-4 w-4' />
						</Button>
						<Button
							onClick={() => {
								const maxPageNumber = Math.ceil(
									qualityData?.chartData?.labels?.length /
									pageLimit?.limit
								);
								if (pageLimit?.number < maxPageNumber) {
									setPageLimit((prev) => {
										return {
											...prev,
											number: prev?.number + 1,
										};
									});
								}
							}}
							variant='outline'
							size='icon'
							disabled={
								pageLimit?.number ===
								Math.ceil(
									qualityData?.chartData?.labels?.length /
									pageLimit?.limit
								)
							}
						>
							<ChevronRight className='h-4 w-4' />
						</Button>
					</div>
				)}
				<BarChart
					key={isYearActive ? 'with-icons' : 'without-icons'}
					data={barChartData}
					onClick={handleBarChartClick}
					className={classes(styles.chart)}
					maintainAspectRatio={false}
					title='Production Cost'
					xAxisCallback={formatTicks}
					stackX
					stackY
					leftLabelName={
						isA2bCustomer
							? viewTabValue === 'TotalWeight'
								? 'Total Weight'
								: viewTabValue === 'TotalCost'
									? `Cost ${measurement === 'US' ? '($)' : '(₹)'}`
									: `Cost ${measurement === 'US' ? '($)' : '(₹)'} (perUnit)`
							: `Cost ${measurement === 'US' ? '($)' : '(₹)'} `
					}
					rightLabelName='Quantity'
					showIconPlugin={isYearActive}
					iconData={iconData}
					onIconClick={handleIconClick}
					iconTooltipFormatter={iconTooltipFormatter}
				/>
			</div>
			<div className={classes(styles.filters)}>
				{GROUP_TYPE_FILTER?.type === 'periodWise' ? (
					<TimeFilter
						timeFilters={timeFilters}
						onClick={renderOnClick}
						graphYear={graphYear}

						setClickedMonth={isA2bCustomer ? setClickedMonth : () => { }}
						clickedMonth={isA2bCustomer ? clickedMonth : -1}
						showDateRangeFilter={isA2bCustomer ? showDateRangeFilter : () => { }}
					/>
				) : (
					<TimeFilter
						timeFilters={Object.keys(
							GROUP_TYPE_FILTER?.selection ?? {}
						)?.map((eleKey) => {
							const eleValue =
								GROUP_TYPE_FILTER?.selection?.[eleKey];
							return {
								type: eleKey,
								text: eleValue?.label,
								active:
									eleKey ===
									GROUP_TYPE_FILTER?.currentSelection,
							};
						})}
						onClick={handleTypeFilter}
					/>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const {
		DATE_FILTER,
		loaders,
		BOM_ANALYTICS,
		GROUP_TYPE_FILTER,
		DATE_RANGE_FILTER: dateRangeFilter,
	} = state.analytics;
	const { LIST: brandsList } = state?.form?.BRANDS?.data ?? {};
	return {
		timeFilter: DATE_FILTER,
		loaders,
		qualityData: BOM_ANALYTICS.CHART_DATA,
		GROUP_TYPE_FILTER,
		brandsList,
		dateRangeFilter,
	};
};

const mapDispatchToProps = {
	applyFilters: analyticsAction.applyFilters,
	setAnalyticsType: analyticsAction.setAnalyticsType,
	setTypeFilter: analyticsAction.setTypeFilter,
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(BOMAnalysisGraph);
